<template>
  <div class="modal">
    <v-dialog :value="value" fullscreen persistent @input="$emit('input')" transition="fade-transition">
      <div>
        <v-card>
          <v-toolbar color="elevation-2">
            <v-toolbar-title class="headline">Create new Campaign</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="close">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container fluid grid-list-lg>
            <v-layout>
              <!-- Company/ Client assignment -->
              <v-flex v-if="needCompany" xs12 md6>
                <v-select
                  :items="company_options"
                  item-text="name"
                  item-value="id"
                  name="state"
                  label="Company"
                  v-model="campaign.companyID"
                  filled
                ></v-select>
              </v-flex>
              <v-flex v-if="needClient" xs12 md6>
                <v-autocomplete
                  filled
                  :items="client_options"
                  label="Client"
                  item-value="id"
                  hide-details
                  item-text="name"
                  v-model="campaign.clientID"
                  @change="setClientData(campaign.clientID)"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-card width="100%">
                  <v-card-title class="title grey lighten-2">
                    Assigned Team
                  </v-card-title>
                  <v-card-text class="grey lighten-3">
                    <v-row>
                      <v-col cols="12" sm="12" md="6" lg="6">
                        <v-subheader>
                          Dedicated Persons
                        </v-subheader>
                        <v-divider style="margin-top:0px;"></v-divider>
                        <v-chip-group active-class="primary--text" v-model="selectedDedicatedPersons" column>
                          <v-chip v-for="(item, index) in dedicatedPersons" :key="index"   :value="item"
                            class="ma-2"
                            filter
                          >
                            <v-avatar style="margin-right:5px;">
                              <v-icon>account_circle</v-icon>
                            </v-avatar>
                            {{item.firstName + ' ' + item.lastName}}
                          </v-chip>
                        </v-chip-group>
                      </v-col>
                      <v-col sm="12" md="6" lg="6">
                        <v-subheader v-show="supportingPersons.length > 0">
                         Supporting Persons
                        </v-subheader>
                        <v-divider v-show="supportingPersons.length > 0" style="margin-top:0px;"></v-divider>
                        <v-chip-group multiple active-class="primary--text" v-model="selectedSupportingPersons" column>
                          <v-chip v-for="(item, index) in supportingPersons" :key="index"  :value="item"
                            class="ma-2"
                            filter
                          >
                              <v-avatar style="margin-right:5px;">
                                <v-icon>account_circle</v-icon>
                              </v-avatar>
                              {{item.firstName + ' ' + item.lastName}}
                            </v-chip>
                          </v-chip-group>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
            <v-layout
              v-for="section in campaignModelSections"
              :name="section.title"
              :key="section.type"
            >
              <!-- Render according to Campaign Model Sections -->
              <v-flex xs12>
                <v-card width="100%">
                  <v-card-title class="title grey lighten-2">
                    {{section.title}}
                    <v-spacer></v-spacer>
                    <v-switch
                      v-model="showVideoBrief"
                      label="Enable Video Brief"
                      v-if="section.type == campaignModelSectionType.VIDEO_BRIEF"
                    ></v-switch>
                    <v-switch
                      v-model="showEventBrief"
                      label="Enable Event Brief"
                      v-if="section.type == campaignModelSectionType.EVENT_BRIEF"
                    ></v-switch>
                  </v-card-title>
                  <v-card-text class="grey lighten-3">
                    <v-container>
                      <v-layout
                        wrap
                        v-if="section.type === campaignModelSectionType.BUDGET_ALLOCATION"
                      >
                        <!-- Comment it out for now by AUNG -->
                        <!-- <v-flex xs12 class="white" v-if="selectedClient != null" elevation-2>
                          <p class="text-center subtitle-1">
                            Usage Summary for <strong>{{selectedClient.name}}</strong> Account
                          </p>
                          <v-layout
                            align-center
                            justify-space-around
                            v-if="clientAccountSummary != null"
                          >
                            <usage-box
                              name="Budget"
                              color="teal"
                              :usage="clientAccountSummary.budgetUsage"
                              :used="clientAccountSummary.usedBudget"
                              :available="selectedClient.account.budget === '' ? 0 : selectedClient.account.budget"
                            />
                            <usage-box
                              name="Outreach"
                              color="blue"
                              :usage="clientAccountSummary.outReachUsage"
                              :used="clientAccountSummary.usedOutreach"
                              :available="selectedClient.account.totalOutreach === '' ? 0 : selectedClient.account.totalOutreach"
                            />
                            <usage-box
                              name="Engagement"
                              color="red"
                              :usage="clientAccountSummary.engagementUsage"
                              :used="clientAccountSummary.usedEngagement"
                              :available="selectedClient.account.totalEngagement === '' ? 0 : selectedClient.account.totalEngagement"
                            />
                            <usage-box
                              name="Content"
                              color="secondary"
                              :usage="clientAccountSummary.contentUsage"
                              :used="clientAccountSummary.usedContent"
                              :available="selectedClient.account.maxContent === '' ? 0 : selectedClient.account.maxContent"
                            />
                            <usage-box
                              name="Campaign"
                              color="green"
                              :usage="clientAccountSummary.campaignUsage"
                              :used="clientAccountSummary.usedCampaigns"
                              :available="selectedClient.account.maxCampaigns === '' ? 0 : selectedClient.account.maxCampaigns"
                            />
                          </v-layout>
                        </v-flex> -->
                        <v-flex xs12 v-if="selectedClient != null">
                           <v-btn
                              color="info"
                              elevation="4"
                              @click="viewClientDialog = true"
                            >
                              Client Details
                               <v-icon
                                right
                                dark
                              >
                                mdi-account-details
                              </v-icon>
                            </v-btn>
                        </v-flex>

                        <v-flex
                          xs12
                          md6
                          xl4
                          v-for="campaignField in section.content"
                          :key="campaignField.name"
                        >
                          <div v-if="campaignField.type === 'select'">
                            <label>{{ campaignField.label }}</label>
                            <v-select
                              solo
                              :name="campaignField.name"
                              :items="IONumberItems"
                              item-text="text"
                              item-value="value"
                              v-model="campaign[campaignField.name]"
                              :placeholder="campaignField.placeholder"
                            ></v-select>
                          </div>

                          <div
                            v-if="campaignField.type === 'slider'"
                            v-bind:class="{ 'has-error': $v.campaign[campaignField.name] && $v.campaign[campaignField.name].$error }"
                          >
                            <label>{{ campaignField.label }}</label>
                            <v-text-field
                              hide-details
                              v-model="campaign[campaignField.name]"
                              :placeholder="campaignField.placeholder"
                              solo type="number"
                            ></v-text-field>
                            <div
                              class="font-weight-light text-xs-right"
                              v-if="selectedClient !== null"
                            >{{getUsage(campaign[campaignField.name],getMaxValueOf(campaignField.name))}}% of Remaining amount</div>
                          </div>

                          <div
                            v-if="campaignField.type === 'text'"
                            v-bind:class="{ 'has-error': $v.campaign[campaignField.name] && $v.campaign[campaignField.name].$error }"
                          >
                            <label>{{ campaignField.label }}</label>
                            <v-text-field
                              solo
                              :placeholder="campaignField.placeholder"
                              v-model="campaign[campaignField.name]"
                            ></v-text-field>
                          </div>

                          <div
                            v-if="campaignField.type === 'date' && campaignField.name === 'startDate'"
                          >
                            <label>{{ campaignField.label }}</label>
                            <v-menu
                              v-model="startCal"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="campaign[campaignField.name]"
                                  append-icon="event"
                                  readonly
                                  solo
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                type="month"
                                v-model="campaign[campaignField.name]"
                                @input="startCal = false"
                              ></v-date-picker>
                            </v-menu>
                          </div>
                          <div
                            v-if="campaignField.type === 'date' && campaignField.name === 'endDate'"
                          >
                            <label>{{ campaignField.label }}</label>
                            <v-menu
                              ref="monthPicker"
                              v-model="endCal"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="campaign[campaignField.name]"
                                  append-icon="event"
                                  readonly
                                  solo
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                type="month"
                                v-model="campaign[campaignField.name]"
                                @input="endCal = false"
                              ></v-date-picker>
                            </v-menu>
                          </div>
                          <div v-if="campaignField.type === 'radio'">
                            <label>{{campaignField.label}}</label>
                            <v-radio-group
                              v-model="campaign[campaignField.name]"
                              row
                            >
                              <v-radio
                                label="by engagement"
                                value="engagement"
                              ></v-radio>
                              <v-radio
                                label="by contents"
                                value="content"
                              ></v-radio>
                            </v-radio-group>
                          </div>
                        </v-flex>
                      </v-layout>

                      <v-layout
                        wrap
                        v-if="
                            (section.type === campaignModelSectionType.CAMPAIGN_SUMMARY) ||
                            (section.type === campaignModelSectionType.INFLUENCER_SELECTION) ||
                            (section.type === campaignModelSectionType.VIDEO_BRIEF && showVideoBrief)"
                      >
                        <!-- For Campaign Summary, Influencer Selection, Video Brief sections -->
                        <v-flex
                          xs12
                          md12
                          xl4
                          v-for="campaignField in section.content"
                          :key="campaignField.name"
                        >
                          <div
                            v-if="campaignField.type === 'text' && campaignField.name === 'vertical'"
                            v-bind:class="{ 'has-error': $v.campaign[campaignField.name] && $v.campaign[campaignField.name].$error }"
                          >
                            <label>{{ campaignField.label }}</label>
                            <v-autocomplete
                              v-model="selectedCampaignVertical"
                              :items="campaignVerticals"
                              item-text="name"
                              item-value="name"
                              hide-selected
                              chips
                              :label="campaignField.placeholder"
                              multiple
                              solo
                              attach
                            >
                              <!-- <template v-slot:no-data>
                                <v-list-item>
                                  <span class="subheading pr-2">Press Enter to Create</span>
                                  <v-chip
                                    label
                                    small
                                  >
                                    {{ newCampaignVertical }}
                                  </v-chip>
                                </v-list-item>
                              </template> -->
                              <!-- <template v-slot:selection="{ attrs, item, parent, selected }">
                                <v-chip
                                  v-if="item === Object(item)"
                                  v-bind="attrs"
                                  :input-value="selected"
                                  label
                                  small
                                >
                                  <span class="pr-2">
                                    {{ item.name }}
                                  </span>
                                  <v-icon
                                    small
                                    @click="parent.selectItem(item)"
                                  >
                                    $delete
                                  </v-icon>
                                </v-chip>
                              </template> -->
                            </v-autocomplete>
                          </div>

                          <div
                            v-else-if="campaignField.type === 'text'"
                            v-bind:class="{ 'has-error': $v.campaign[campaignField.name] && $v.campaign[campaignField.name].$error }"
                          >
                            <label>{{ campaignField.label }}</label>
                            <v-text-field
                              solo
                              :placeholder="campaignField.placeholder"
                              v-model="campaign[campaignField.name]"
                            ></v-text-field>
                          </div>

                          <div
                            v-if="campaignField.type === 'textarea'"
                            v-bind:class="{ 'has-error': $v.campaign[campaignField.name] && $v.campaign[campaignField.name].$error }"
                          >
                            <label>{{ campaignField.label }}</label>
                            <v-textarea
                              solo
                              :placeholder="campaignField.placeholder"
                              v-model="campaign[campaignField.name]"
                            ></v-textarea>
                          </div>

                          <div v-if="campaignField.type === 'combobox'">
                            <label>{{ campaignField.label }}</label>
                            <v-combobox
                              v-model="campaign[campaignField.name]"
                              :items="campaignField.items"
                              multiple
                              solo
                              chips
                              :placeholder="campaignField.placeholder"
                              v-if="campaignField.name === 'targetAge'"
                              v-on:input="targetAgelimiter"
                            ></v-combobox>
                            <v-autocomplete
                              :search-input.sync="newCountry"
                              v-model="campaign[campaignField.name]"
                              :items="countries"
                              item-text="name"
                              item-value="code"
                              hide-selected
                              multiple
                              solo
                              chips
                              label="Country"
                              dense
                              v-else-if="campaignField.name === 'targetLocation'"
                            >
                              <!-- <template v-slot:no-data>
                                <v-list-item>
                                  <span class="subheading pr-2">Press Enter to Create</span>
                                  <v-chip
                                    label
                                    small
                                  >
                                    {{ newCountry }}
                                  </v-chip>
                                </v-list-item>
                              </template> -->
                              <template v-slot:selection="{ attrs, item, parent, selected }">
                                <v-chip
                                  v-if="item === Object(item)"
                                  v-bind="attrs"
                                  :input-value="selected"
                                  label
                                  small
                                >
                                  <span class="pr-2">
                                    {{ item.name }}
                                  </span>
                                  <v-icon
                                    small
                                    @click="parent.selectItem(item)"
                                  >
                                    $delete
                                  </v-icon>
                                </v-chip>
                                <v-chip
                                  v-else
                                  v-bind="attrs"
                                  :input-value="selected"
                                  label
                                  small
                                >
                                  <span class="pr-2">
                                    {{ item }}
                                  </span>
                                  <v-icon
                                    small
                                    @click="parent.selectItem(item)"
                                  >
                                    $delete
                                  </v-icon>
                                </v-chip>
                              </template>
                            </v-autocomplete>
                            <v-combobox
                              v-model="campaign[campaignField.name]"
                              :items="campaignField.items"
                              multiple
                              solo
                              chips
                              :placeholder="campaignField.placeholder"
                              v-else
                            ></v-combobox>
                          </div>

                          <div v-if="campaignField.type === 'select'">
                            <label>{{ campaignField.label }}</label>
                            <v-select
                              solo
                              :name="campaignField.name"
                              :items="campaignField.value"
                              item-text="text"
                              item-value="value"
                              v-model="campaign[campaignField.name]"
                              v-if="campaignField.name==='name'"
                              @change="changeCampaignName(campaign[campaignField.name])"
                            ></v-select>
                            <v-select
                              solo
                              :name="campaignField.name"
                              :items="campaignField.value"
                              item-text="text"
                              item-value="value"
                              v-model="campaign[campaignField.name]"
                              v-else
                            ></v-select>
                          </div>
                          <div v-if="campaignField.type === 'autocomplete'">
                            <label>{{ campaignField.label }}</label>
                            <v-autocomplete
                              v-model="campaign[campaignField.name]"
                              :items="campaignField.value"
                              item-text="text"
                              item-value="name"
                              hide-selected
                              chips
                              :label="campaignField.placeholder"
                              multiple
                              solo
                              attach
                            >
                              <template v-slot:selection="{ attrs, item, parent, selected }">
                                <v-chip
                                  v-if="item === Object(item)"
                                  v-bind="attrs"
                                  :input-value="selected"
                                  label
                                  small
                                >
                                  <span class="pr-2">
                                    {{ item.text }}
                                  </span>
                                  <v-icon
                                    small
                                    @click="parent.selectItem(item)"
                                  >
                                    $delete
                                  </v-icon>
                                </v-chip>
                              </template>
                            </v-autocomplete>
                          </div>

                          <div
                            v-if="campaignField.type === 'chips'"
                          >
                            <label>{{ campaignField.label }}</label>
                            <draggable v-model="campaign[campaignField.name]" style="width:100%;" class="row no-gutters flex-wrap flex-row fill-height" >
                              <v-chip v-for="(item, index) in campaign[campaignField.name]" :key="index"  :value="item"
                                class="ma-2"
                                filter
                              >
                                {{item.text}}
                              </v-chip>
                            </draggable>
                          </div>

                          <div v-if="campaignField.type == 'upload'">
                            <label>{{ campaignField.label }}</label>
                            <div class="canvas-image-input">
                              <input
                                type="file"
                                ref="files"
                                @change="processImage($event, 'canvas', null, null, 'canvas')"
                              />
                            </div>
                          </div>

                          <div
                            v-if="campaignField.type === 'date' && campaignField.name === 'video_live_date'"
                          >
                            <label>{{ campaignField.label }}</label>
                            <v-menu
                              v-model="videoDateDialog"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="campaign[campaignField.name]"
                                  append-icon="event"
                                  readonly
                                  solo
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="campaign[campaignField.name]"
                                @input="videoDateDialog = false"
                              ></v-date-picker>
                            </v-menu>
                          </div>
                        </v-flex>
                      </v-layout>

                      <v-layout wrap v-if="section.type === campaignModelSectionType.CONTENT_ANGLE">
                        <!-- For Content Angle Section -->
                        <v-flex
                          xs12
                          v-for="campaignField in section.content"
                          :key="campaignField.name"
                        >
                          <div v-if="campaignField.type === 'select'" class="action-required">
                            <label>{{ campaignField.label }}</label>
                            <v-select
                              solo
                              :name="campaignField.name"
                              :items="campaignField.value"
                              item-text="text"
                              item-value="value"
                              v-model="campaign[campaignField.name]"
                            ></v-select>
                          </div>
                          <div v-if="campaignField.type === 'multiple_options'">
                            <div
                              v-for="(option, optionIndex) in campaign[campaignField.name]"
                              :key="optionIndex"
                            >
                              <h4>
                                {{ campaignField.label }} {{ optionIndex + 1 }}
                                <v-btn
                                  text
                                  icon
                                  color="red"
                                  v-if="campaign[campaignField.name].length > 1"
                                  @click.stop="deleteOption(campaignField.name, optionIndex)"
                                >
                                  <i class="fa fa-trash ims-text-error"></i>
                                </v-btn>
                              </h4>
                              <v-container>
                                <v-layout wrap>
                                  <v-flex
                                    xs12
                                    v-for="(optionField, i) in campaignField.template"
                                    :key="i"
                                  >
                                    <div v-if="optionField.type == 'text'">
                                      <label>{{ optionField.label }}</label>
                                      <v-text-field
                                        solo
                                        v-model="campaign[campaignField.name][optionIndex][optionField.name]"
                                        :placeholder="optionField.placeholder"
                                      ></v-text-field>
                                    </div>

                                    <div v-if="optionField.type == 'textarea'">
                                      <label>{{ optionField.label }}</label>
                                      <v-textarea
                                        solo
                                        v-model="campaign[campaignField.name][optionIndex][optionField.name]"
                                        :placeholder="optionField.placeholder"
                                      ></v-textarea>
                                    </div>

                                    <div v-if="optionField.type == 'multiple_options'">
                                        <div v-for="(secondOption, secondOptionIndex) in campaign[campaignField.name][optionIndex][optionField.name]" :key="secondOptionIndex">
                                          <h4>
                                            Required Action {{ secondOptionIndex + 1 }}
                                            <v-btn
                                              text
                                              icon
                                              color="red"
                                              v-if="campaign[campaignField.name][optionIndex][optionField.name].length > 1"
                                              @click.stop="deleteSecondOption(campaignField.name, optionIndex, optionField.name, secondOptionIndex)"
                                            >
                                              <i class="fa fa-trash ims-text-error"></i>
                                            </v-btn>
                                          </h4>
                                          <v-layout wrap v-for="(optionField2, optionIndex2) in optionField.template" :key="optionIndex2">
                                            <v-flex
                                              xs6
                                              v-for="(format, i) in optionField2"
                                              :key="i"
                                            >
                                              <div v-if="format.type == 'text'">
                                                <label>{{ format.label }}</label>
                                                <v-text-field
                                                  solo
                                                  v-model="campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]"
                                                  :placeholder="format.placeholder"
                                                ></v-text-field>
                                              </div>

                                              <div v-if="format.type == 'textarea'">
                                                <label>{{ format.label }}</label>
                                                <v-textarea
                                                  solo
                                                  v-model="campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]"
                                                  :placeholder="format.placeholder"
                                                ></v-textarea>
                                              </div>
                                              <div v-if="format.type === 'combobox'">
                                                <label>{{ format.label }}</label>
                                                <v-combobox
                                                  v-model="campaign[campaignField.name][optionIndex][optionField.name][secondOptionIndex][format.name]"
                                                  :items="format.items"
                                                  multiple
                                                  solo
                                                  chips
                                                  :placeholder="format.placeholder"
                                                  append-icon=""
                                                ></v-combobox>
                                              </div>
                                              <div v-if="format.type == 'upload'">
                                                <label>{{ format.label }}</label>
                                                <div
                                                  class="image-input-container"
                                                  :id="'optionImages_' + optionIndex + '_' + secondOptionIndex"
                                                  :data-index="optionIndex"
                                                >
                                                  <div class="input-group pb-2" :id="'input_group_0_' + optionIndex + '_' + secondOptionIndex">
                                                    <label class="pr-2">
                                                      <input type='radio' :id="'radio_image_' + optionIndex + '_' + secondOptionIndex" :name="'type_' + optionIndex + '_' + secondOptionIndex" value="image" checked="true" @change="changeOptionType('0_' + optionIndex + '_' + secondOptionIndex, 'image')" /> Image
                                                    </label>
                                                    <label>
                                                      <input type='radio' :id="'radio_link_' + optionIndex + '_' + secondOptionIndex" :name="'type_' + optionIndex + '_' + secondOptionIndex" value='link' @change="changeOptionType('0_' + optionIndex + '_' + secondOptionIndex, 'link')" /> Video Link
                                                    </label>
                                                    <div>
                                                      <input type="text" class="custom-input" style="display:none" :id="'video_link_0_' + optionIndex + '_' + secondOptionIndex" @keyup="changeVideoLink('angel', optionIndex, secondOptionIndex, 0 + '_' + optionIndex + '_' + secondOptionIndex)" />
                                                    </div>
                                                    <div class="image-input" :id="'img_upload_0_' + optionIndex + '_' + secondOptionIndex">
                                                      <input
                                                        type="file"
                                                        ref="files"
                                                        @change="processImage($event, 'angel', optionIndex, secondOptionIndex, 0 + '_' + optionIndex + '_' + secondOptionIndex)"
                                                      />
                                                    </div>
                                                  </div>
                                                  <button
                                                    type="button"
                                                    class="btn btn-link btn-link-danger btn-remove-input"
                                                    @click.prevent="removeImage(optionIndex, 0 + '_' + optionIndex + '_' + secondOptionIndex)"
                                                  >Remove</button>
                                                </div>
                                                <button
                                                  type="button"
                                                  class="btn btn-default btn-sm btn-add-more-image"
                                                  @click="addMoreImage(optionIndex, secondOptionIndex)"
                                                >+ Add more image</button>
                                              </div>
                                            </v-flex>
                                          </v-layout>
                                        </div>
                                        <v-btn
                                          small
                                          class="default"
                                          @click="addSecondOption(campaignField.name, optionIndex, optionField.name)"
                                        >+ Add Required Action</v-btn>
                                    </div>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </div>
                            <v-divider></v-divider>
                            <div>
                              <v-btn
                                small
                                class="secondary"
                                @click="addOption(campaignField.name)"
                              >Add new Concept</v-btn>
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>

                      <v-layout wrap v-if="section.type === campaignModelSectionType.EVENT_BRIEF && showEventBrief">
                        <!-- For Event Brief -->
                        <v-flex
                          xs12
                          v-for="campaignField in section.content"
                          :key="campaignField.name"
                        >
                          <div
                            v-if="campaignField.type === 'textarea'"
                          >
                            <label>{{ campaignField.label }}</label>
                            <v-textarea
                              solo
                              :placeholder="campaignField.placeholder"
                              v-model="campaign.eventBrief[campaignField.name]"
                            ></v-textarea>
                          </div>

                          <div v-if="campaignField.type === 'multiple_options'">
                            <h4>
                              {{ campaignField.label }}
                            </h4>
                            <div
                              v-for="(option, optionIndex) in campaign.eventBrief[campaignField.name]"
                              :key="optionIndex"
                            >
                              <v-container>
                                <v-layout wrap>
                                  <v-flex
                                    xs12
                                    md3
                                    v-for="(optionField, i) in campaignField.template"
                                    :key="i"
                                  >
                                    <div v-if="optionField.type == 'text'">
                                      <label>{{ optionField.label }}</label>
                                      <v-icon
                                        text icon color="red"
                                        v-if="campaign.eventBrief[campaignField.name].length > 1"
                                        v-show="optionField.name === 'attendeeName'"
                                        @click.stop="deleteAttendee(campaignField.name, optionIndex)"
                                      >delete</v-icon>
                                      <v-text-field
                                        solo
                                        v-model="campaign.eventBrief[campaignField.name][optionIndex][optionField.name]"
                                        :placeholder="optionField.placeholder"
                                      ></v-text-field>
                                    </div>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </div>
                            <div>
                              <v-btn
                                small
                                class="secondary"
                                @click="addAttendee(campaignField.name)"
                              >Add an Attendee</v-btn>
                            </div>
                          </div>
                          <div v-if="campaignField.type === 'template'">
                            <h4>
                              {{ campaignField.label }}
                            </h4>
                            <v-container>
                              <v-layout wrap>
                                <v-flex
                                  xs12 md4
                                  v-for="(templateField, i) in campaignField.template"
                                  :key="i"
                                >
                                  <div v-if="templateField.type == 'text'">
                                    <label>{{ templateField.label }}</label>
                                    <v-text-field
                                      solo
                                      v-model="campaign.eventBrief[campaignField.name][templateField.name]"
                                      :placeholder="templateField.placeholder"
                                    ></v-text-field>
                                  </div>

                                  <div v-if="templateField.type === 'radioButton'">
                                    <label>{{ templateField.label }}</label>
                                    <v-checkbox
                                      v-model="campaign.eventBrief[campaignField.name][templateField.name]"
                                      :label="campaign.eventBrief[campaignField.name][templateField.name] ? 'Yes': 'No'"
                                    ></v-checkbox>
                                  </div>

                                  <div
                                    v-if="templateField.type === 'date' && templateField.name === 'eventDate'"
                                  >
                                    <label>{{ templateField.label }}</label>
                                    <v-menu
                                      v-model="eventDateDialog"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="290px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          v-model="campaign.eventBrief[campaignField.name][templateField.name]"
                                          append-icon="event"
                                          readonly
                                          solo
                                          v-on="on"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker
                                        v-model="campaign.eventBrief[campaignField.name][templateField.name]"
                                        @input="eventDateDialog = false"
                                      ></v-date-picker>
                                    </v-menu>
                                  </div>

                                  <div
                                    v-if="templateField.type === 'textarea'"
                                  >
                                    <label>{{ templateField.label }}</label>
                                    <v-textarea
                                      solo
                                      :placeholder="templateField.placeholder"
                                      v-model="campaign.eventBrief[campaignField.name][templateField.name]"
                                    ></v-textarea>
                                  </div>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>

          <!-- Footer -->
          <div class="modal-footer">
            <v-btn @click="close">Close</v-btn>
            <v-btn :disabled="submitting" class="secondary" @click.prevent="createCampaign">
              <i class="fa fa-circle-o-notch fa-spin" v-if="submitting"></i>
              Save Changes
            </v-btn>
          </div>
        </v-card>
      </div>
      <loading :active.sync="submitting" :can-cancel="false" :is-full-page="true" />
    </v-dialog>
    <!-- ViewClient modal -->
    <view-client-modal :clientData="viewClientData" v-model="viewClientDialog"/>
  </div>
</template>

<script>
import $ from 'jquery';
// import { mapState } from 'vuex';
import campaignConfig from './config';
import campaignAPIs from './campaignAPIs';
import companyAPIs from '../Company/companyAPIs';
import clientAPIs from '../Client/clientAPIs';
import config from '@/config';
import utils from '../../../utils';
import UsageBox from './UsageCircularBox.vue';
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
// import api from '@/api'
import ViewClientModal from '../Client/ViewClientModal'
import userAPIs from '../User/userAPIs'
import draggable from 'vuedraggable'
import countries from '../../../../static/sources/countries';

var campaignData = {
  companyID: '',
  clientID: '',
  enableVideoBrief: false
};

export default {
  name: 'CreateCampaignModal',
  props: {
    value: Boolean
  },
  data() {
    return {
      submitting: false,
      showVideoBrief: false,
      showEventBrief: false,
      company_options: [],
      allClients: [],
      selectedClient: null,
      search: null,
      startCal: false,
      endCal: false,
      startTimeDialog: false,
      endTimeDialog: false,
      eventDateDialog: false,
      videoDateDialog: false,
      previewImage: null,
      clientAccountSummary: {
        clientID: null,
        budgetUsage: 0,
        campaignUsage: 0,
        contentUsage: 0,
        outReachUsage: 0,
        engagementUsage: 0,
        usedBudget: 0,
        usedCampaigns: 0,
        usedContent: 0,
        usedEngagement: 0,
        usedOutreach: 0
      },
      clientCampaigns: [],
      campaign: campaignData,
      campaignModelSections: campaignConfig.campaignModelSections,
      campaignModelSectionType: campaignConfig.campaignModelSectionType,
      images: [],
      angelOptions: [],
      viewClientData: null,
      viewClientDialog: false,
      AM: [],
      selectedAM: [],
      CO: [],
      selectedCO: [],
      dedicatedPersons: [],
      supportingPersons: [],
      selectedDedicatedPersons: [],
      selectedSupportingPersons: [],
      IONumberItems: [],
      campaignVerticals: [],
      selectedCampaignVertical: [],
      newCampaignVertical: '',
      countries: [] // For filter influencer
    };
  },
  components: {
    UsageBox,
    Loading,
    ViewClientModal,
    draggable
  },
  validations: function() {
    const validationRules = {
      campaign: {}
    };
    this.campaignModelSections.forEach(section => {
      section.content.forEach(field => {
        if (field.validations && field.validations.length > 0) {
          field.validations.forEach(validation => {
            validationRules['campaign'][field.name] = {
              [validation.name]: validation.value
            };
          });
        }
      });
    });

    return validationRules;
  },
  watch: {
    showVideoBrief: function(val) {
      this.campaign.settings = { enableVideoBrief: val };
    },
    showEventBrief: function(val) {
      this.campaign.settings = { enableEventBrief: val };
    },
    selectedCampaignVertical (val, prev) {
      if (val.length === prev.length) return

      this.selectedCampaignVertical = val.map(v => {
        if (typeof v === 'string') {
          v = {
            id: 0,
            name: v
          }
          this.campaignVerticals.push(v)
        }

        return v
      })
    }
  },
  computed: {
    // ...mapState({
    //   countries: state => state.campaign.countries
    // }),
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    },
    currentUserID: function() {
      return this.$store.state.user.id;
    },
    client_options: function() {
      let clientList = []
      this.allClients.forEach(element => {
        let client = {
          name: element.name,
          id: element.id
        }
        clientList.push(client)
      });
      return clientList;
    },
    needCompany: function() {
      // If a new campaign is created naturally (but not by system admin),
      // then do not display the company dropdown list
      if (this.currentUserRole === config.userRoles.COMPANY_ADMIN_HIGH || this.currentUserRole === config.userRoles.COMPANY_ADMIN_LOW) {
        return false;
      } else if (this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === config.userRoles.SUPER_ADMIN_LOW) {
        return true;
      }

      return false;
    },
    needClient: function() {
      // If a new campaign is created naturally (but not by system admin),
      // then do not display the company dropdown list
      if (
        this.needCompany ||
        this.currentUserRole === config.userRoles.COMPANY_ADMIN_HIGH ||
        this.currentUserRole === config.userRoles.COMPANY_ADMIN_LOW ||
        this.currentUserRole === config.userRoles.AD_STRATEGIST ||
        this.currentUserRole === config.userRoles.ACCOUNT_MANAGER
      ) {
        return true;
      }

      return false;
    }
  },
  methods: {
    close() {
      this.clearData();
      this.$emit('input');
    },
    getUsage: (used, available) => {
      return Math.ceil((used / available) * 100);
    },
    getMaxValueOf(campaignFieldName) {
      if (this.selectedClient === null || this.clientAccountSummary === null) {
        return;
      } else {
        switch (campaignFieldName) {
          case 'budget':
            return this.selectedClient.account.budget - this.clientAccountSummary.usedBudget;
          case 'outreach':
            return this.selectedClient.account.totalOutreach - this.clientAccountSummary.usedOutreach;
          case 'engagement':
            return this.selectedClient.account.totalEngagement - this.clientAccountSummary.usedEngagement;
          case 'min_content':
            return this.selectedClient.account.maxContent - this.clientAccountSummary.usedContent;
          case 'max_content':
            return this.selectedClient.account.maxContent - this.clientAccountSummary.usedContent;
          default:
            return 0;
        }
      }
    },
    addMoreImage(optionIndex, secondOptionIndex) {
      let el = document.getElementById('optionImages_' + optionIndex + '_' + secondOptionIndex);
      let img = this.renderImageSelection(optionIndex, secondOptionIndex);
      let imgId = img.id;
      el.insertAdjacentHTML('beforeend', img.html);
      let btnRemove = document.getElementById('btnRemove_' + imgId);
      let inputFile = document.getElementById('inputFile_' + imgId);
      btnRemove.addEventListener('click', () => {
        this.removeImage(optionIndex, imgId);
      });
      inputFile.addEventListener('change', event => {
        this.processImage(event, 'angel', optionIndex, secondOptionIndex, imgId);
      });
      let imageRadio = document.getElementById('radio_image_' + imgId)
      imageRadio.addEventListener('change', event => {
        this.changeOptionType(imgId, 'image')
      });
      let linkRadio = document.getElementById('radio_link_' + imgId)
      linkRadio.addEventListener('change', event => {
        this.changeOptionType(imgId, 'link')
      });
      let videoLinkInput = document.getElementById('video_link_' + imgId)
      videoLinkInput.addEventListener('change', event => {
        this.changeVideoLink('angel', optionIndex, secondOptionIndex, imgId)
      });
    },
    removeImage(optionIndex, imgId) {
      var el = document.getElementById('input_group_' + imgId);
      el.remove();
      utils.func.removeElementFromArray(this.images, imgId, 'imgId', utils.TYPE.OBJECT);
      utils.func.removeElementFromArray(this.angelOptions, imgId, 'imgId', utils.TYPE.OBJECT);
    },
    renderImageSelection(optionIndex) {
      let imgIndex = utils.func.makeid(6);
      return {
        html: `
        <div class="input-group pb-2" id="input_group_${imgIndex}">
          <label class="pr-2">
            <input type='radio' id="radio_image_${imgIndex}" name="type_${imgIndex}" value='image' checked="true" /> Image
          </label>
          <label>
            <input type='radio' id="radio_link_${imgIndex}" name="type_${imgIndex}" value='link' /> Video Link
          </label>
          <div>
            <input type="text" class="custom-input" style="display:none" id="video_link_${imgIndex}" />
          </div>
          <div
            class="image-input" id="img_upload_${imgIndex}"
          >
            <input
              type="file"
              id="inputFile_${imgIndex}"
              ref="files"
            />
          </div>
        </div>
        <button
          type="button"
          id="btnRemove_${imgIndex}"
          class="btn btn-link btn-link-danger btn-remove-input"
        >Remove</button>`,
        id: imgIndex
      };
    },
    setClientData: function(clientID) {
      this.getSummaryAccountDetails(clientID);
      this.getClientData(clientID);
      this.allClients.map(client => {
        if (client.id === clientID) {
          this.selectedClient = client;
        }
      });
      this.getCampaignsByClientID(clientID)
    },
    getSummaryAccountDetails: function(clientID) {
      clientAPIs
        .getClientAccountSummary(clientID)
        .then(response => {
          response.deals.map(item => {
            this.IONumberItems.push(item.IO)
          })
          this.clientAccountSummary = Object.assign({}, response);
        })
        .catch(error => {
          // Request failed.
          console.log('error', error);
        });
    },
    getClientData: function(clientID) {
      clientAPIs
        .getClient(clientID)
        .then(response => {
          this.viewClientData = Object.assign({}, response)
          this.getPersonsFromClient(this.viewClientData.handledBy, this.viewClientData.supportedBy || [])
        })
        .catch(error => {
          // Request failed.
          console.log('error', error);
        });
    },
    getCampaignsByClientID: function(clientID) {
      campaignAPIs
      .getCampaignsByClientID(clientID)
      .then(response => {
        this.campaignModelSections = this.campaignModelSections.map(section => {
          if (section.type === this.campaignModelSectionType.CAMPAIGN_SUMMARY) { // for campaign name
            // var eventObject = {};
            section.content.forEach(field => {
              if (field.name === 'name') {
                field.value = []
                this.clientCampaigns = response.campaigns
                response.campaigns.map(c => {
                  field.value.push(c.name)
                })
              }
            })
          }
          return section
        })
      })
      .catch(error => {
        // Request failed.
        console.log('error', error);
      });
    },
    getPersonsFromClient: function(handledBy, supportedBy = []) {
      this.dedicatedPersons = []
      this.selectedDedicatedPersons = []
      this.supportingPersons = []
      this.selectedSupportingPersons = []
      // Get all dedicated or supporting user by Client
      handledBy.map((userId) => {
        userAPIs
        .getUser(userId)
        .then(response => {
          this.dedicatedPersons.push(response)
          this.selectedDedicatedPersons.push(response)
        })
        .catch(error => {
          console.log('error', error);
        });
      })
      supportedBy.map((userId) => {
        userAPIs
        .getUser(userId)
        .then(response => {
          this.supportingPersons.push(response)
          this.selectedSupportingPersons.push(response)
        })
        .catch(error => {
          console.log('error', error);
        });
      })
    },
    createCampaign: function() {
      if (this.campaign.campaignType === campaignConfig.campaignType.NO_PREFERENCE) {
        this.$swal({
          type: 'error',
          title: `Can't Submit with errors`,
          text: 'Please Select Campaign Type.'
        });
        return;
      } else if (this.selectedCampaignVertical.length === 0) {
        this.$swal({
          type: 'error',
          title: `Can't Submit with errors`,
          text: 'Please Select Campaign Vertical.'
        });
        return;
      }
      const campaign = Object.assign({}, this.campaign);
      const campaignID = campaign.id;
      // let AMUserList = []
      // let COUserList = []

      // this.selectedAM.map((item) => {
      //   AMUserList.push(item.id)
      // })

      // this.selectedCO.map((item) => {
      //   COUserList.push(item.id)
      // })

      // if (this.currentUserRole === config.userRoles.ACCOUNT_MANAGER) {
      //   AMUserList.map((item) => {
      //     if (item.id !== this.currentUserID) {
      //       AMUserList.push(this.currentUserID)
      //     }
      //   })
      // }

      // if (this.currentUserRole === config.userRoles.AD_STRATEGIST) {
      //   COUserList.map((item) => {
      //     if (item.id !== this.currentUserID) {
      //       COUserList.push(this.currentUserID)
      //     }
      //   })
      // }

      // Reassign Campaign Vertical data to store
      campaign['vertical'] = this.selectedCampaignVertical
      // let userList = AMUserList.concat(COUserList)
      // const userListSet = new Set(userList)
      // campaign.assignedTo = [...userListSet]
      campaign.assignedTo = this.selectedDedicatedPersons.map(d => d.id)
      campaign.assignedSupportingTo = this.selectedSupportingPersons.map(sp => sp.id)

      // check and assign target audience age
      campaign['targetAge'] = campaign['targetAge'] ? campaign['targetAge'].map(t => t.value) : []

      // check and assign target aud location
      if (campaign['targetLocation']) {
        campaign['targetLocation'] = campaign['targetLocation'].map(v => {
          if (typeof v === 'string') {
            v = {
              id: 0,
              name: v,
              code: v
            }
            // this.countries.push(v)
          }
          return v
        })
      }

      // check and assign target audience age
      campaign['platform'] = campaign['platform'] ? campaign['platform'].map(t => t.value) : []

      // check and assign segmentation
      campaign['segment'] = campaign['segment'] ? campaign['segment'].map(t => t.value) : []

      if (this.needCompany === false) {
        // If campaign is created by company admin or ad strategist then we do not need to set this explicitly but let server handle the assignment
        delete campaign.companyID;
      }
      let formData = new FormData();
      formData.append('campaign', JSON.stringify(campaign));
      formData.append('angelOptions', JSON.stringify(this.angelOptions));
      for (let val of this.images) {
        formData.append('images', val.element);
      }

      this.$swal({
        title: 'Double Check!',
        text: 'Make sure you filled all the required information',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        if (result.value) {
          // Update submitting status
          this.submitting = true;
          // Submit request to create campaign
          campaignAPIs
            .editCampaign(campaignID, formData)
            .then(response => {
              // Return the newly added data to parent component
              this.$emit('createCampaign', response);
              // Dismiss modal by triggering the click event on Close button
              this.clearData();
              this.close();
              // Update submitting status
              this.submitting = false;
              // Show success message
              this.$swal({
                text: 'Campaign Created',
                type: 'success'
              });
            })
            .catch(error => {
              // Update submitting status
              this.submitting = false;
              // Request failed.
              console.log('error', error);
              this.$swal({
                text: error,
                type: 'error'
              });
            });
        }
      });
    },
    processImage: function(e, type, opt, opt2, imgId) {
      const uploadedFiles = Object.keys(e.target.files).map(i => e.target.files[i]);
      uploadedFiles.forEach(element => {
        utils.func.pushElementToArray(this.angelOptions, { opt, opt2, name: element.name, type, imgId }, 'imgId', utils.TYPE.OBJECT);
        utils.func.pushElementToArray(this.images, { element, imgId, opt, opt2 }, 'imgId', utils.TYPE.OBJECT);
      });
    },
    addAttendee: function(fieldName) {
      var attendeeField = this.campaign['eventBrief'][fieldName][0];
      var newAttendeeField = {}
      for (var key in attendeeField) {
        newAttendeeField[key] = '';
      }
      // var newAttendeeField = Object.assign({}, attendeeField);
      this.campaign['eventBrief'][fieldName].push(newAttendeeField);
    },
    deleteAttendee: function(fieldName, index) {
      var newAttendeeField = this.campaign['eventBrief'][fieldName];
      if (index < newAttendeeField.length) {
        newAttendeeField.splice(index, 1);
        this.campaign['eventBrief'][fieldName] = newAttendeeField;
      }
    },
    deleteOption: function(campaignAttribute, campaignAttributeIndex) {
      var campaignOptions = this.campaign[campaignAttribute];
      if (campaignAttributeIndex < campaignOptions.length) {
        campaignOptions.splice(campaignAttributeIndex, 1);
        this.campaign[campaignAttribute] = campaignOptions;
        this.angelOptions = this.angelOptions.filter((e) => {
          return e.opt !== campaignAttributeIndex
        })
        this.images = this.images.filter((e) => {
          return e.opt !== campaignAttributeIndex
        })
      }
    },
    deleteSecondOption: function(campaignAttribute, campaignAttributeIndex, optionName, optionIndex) {
      var secondOptions = this.campaign[campaignAttribute][campaignAttributeIndex][optionName]
      if (optionIndex < secondOptions.length) {
        secondOptions.splice(optionIndex, 1);
        this.campaign[campaignAttribute][campaignAttributeIndex][optionName] = secondOptions;
      }
    },
    addOption: function(campaignAttribute) {
      var campaignOptions = this.campaign[campaignAttribute];
      if (campaignOptions.length > 0) {
        var campaignOptionsTemplate = {};
        // default selection in newly added options
        for (var key in campaignOptions[0]) {
          if (campaignAttribute === 'angles') {
            if (
              key === 'actionRequired_action' ||
              key === 'actionRequired_receive' ||
              key === 'actionRequired_time' ||
              key === 'actionRequired_value' ||
              key === 'formats'
            ) {
              campaignOptionsTemplate[key] = campaignOptions[0][key];
              if (key === 'formats') {
                campaignOptionsTemplate[key] = [this.getAngleFormat()]
              }
            }
          } else {
            campaignOptionsTemplate[key] = '';
          }
        }
        // console.log(campaignOptionsTemplate)
        campaignOptions.push(campaignOptionsTemplate);
        this.campaign[campaignAttribute] = campaignOptions;
      }
    },
    addSecondOption(campaignAttribute, optionIndex, optionName) {
      // add second option
      var campaignOptions = this.campaign[campaignAttribute][optionIndex][optionName];
      if (campaignOptions.length > 0) {
        var campaignOptionsTemplate = {};
        // default selection in newly added options
        for (var key in campaignOptions[0]) {
          campaignOptionsTemplate[key] = '';
          if (key === 'formats') {
            let format = this.getAngleFormat()
            campaignOptionsTemplate[key] = format
          }
        }
        campaignOptions.push(campaignOptionsTemplate);
        this.campaign[campaignAttribute][optionIndex][optionName] = campaignOptions;
      }
    },
    changeOptionType(elementID, value) {
      $(`#img_upload_${elementID}`).hide()
      $(`#video_link_${elementID}`).hide()
      if (value === 'image') {
        $(`#img_upload_${elementID}`).show()
      } else {
        $(`#video_link_${elementID}`).show()
      }
    },
    changeVideoLink(type, opt, opt2, imgId) {
      let value = $(`#video_link_${imgId}`).val()
      utils.func.pushElementToArray(this.angelOptions, { opt, opt2, name: value, type, optionType: 'link', imgId }, 'imgId', utils.TYPE.OBJECT);
    },
    getAngleFormat() {
      return Object.assign({}, {
        required_action: '',
        image_angle: '',
        content_angle: '',
        sample_images: ''
      })
    },
    changeCampaignName(name) {
      let campaignOne = this.clientCampaigns.find(c => c.name === name)
      if (typeof campaignOne.targetAge === 'string') {
        campaignOne.targetAge = [campaignOne.targetAge]
      }
      if (typeof campaignOne.targetLocation === 'string') {
        if (campaignOne.targetLocation === '-') {
          campaignOne.targetLocation = ''
        } else {
          let location = campaignConfig.targetAudienceDisplay.LOCATION.find(l => l.text === campaignOne.targetLocation)
          if (location) campaignOne.targetLocation = [location.value]
        }
      }
      campaignOne.goal = Array.isArray(campaignOne.goal) ? campaignOne.goal : [campaignOne.goal]
      campaignOne.influencer_ideal = Array.isArray(campaignOne.influencer_ideal) ? campaignOne.influencer_ideal : [campaignOne.influencer_ideal]
      campaignOne.influencer_unwanted = Array.isArray(campaignOne.influencer_unwanted) ? campaignOne.influencer_unwanted : [campaignOne.influencer_unwanted]
      this.campaign = utils.func.refreshJSON(campaignOne)
    },
    clearData: function() {
      this.selectedClient = null;
      this.clientAccountSummary = {};
    },
    initFileUpload() {
      // $(document).on('click', '.btn-add-more-image', function(event) {
      //   event.preventDefault();
      //   $(this).prev('.image-input-container').append(`
      //     <div class="image-input">
      //       <input type="file" ref="files"/>
      //       <button type="button" class="btn btn-link btn-remove-input">Remove</button>
      //     </div>
      //   `);
      // });

      $(document).on('click', '.btn-remove-input', function() {
        $(this)
          // .parent()
          .remove();
      });
    },
    targetAgelimiter(e) { // limit target age select to three
      if (e.length > 3) {
        e.pop()
      }
    },
    getCountries() {
      // Retrieve countries manually
      this.countries = Object.assign([], countries)
      // influencerAPIs.getCountries().then(countries => {
      //   this.countries = countries.map(item => item.name);
      // });
    }
  },
  beforeCreate() {
    // Update campaign data value based on campaign model
    campaignConfig.campaignModelSections.forEach(section => {
      if (section.type === campaignConfig.campaignModelSectionType.EVENT_BRIEF) { // for video-brief
        var eventObject = {};
        section.content.forEach(field => {
          if (field.type === 'multiple_options') {
            var optionObj = {};
            field.template.forEach(template => {
              optionObj[template.name] = '';
            })
            eventObject[field.name] = [optionObj];
          } else if (field.type === 'template') {
            var templateObj = {};
            field.template.forEach(template => {
              templateObj[template.name] = ''
            })
            eventObject[field.name] = templateObj;
          } else {
            eventObject[field.name] = '';
          }
        })
        campaignData.eventBrief = eventObject;
      } else { // for other sections type
        section.content.forEach(field => {
          campaignData[field.name] = '';

          if (field.type === 'select') {
            campaignData[field.name] = field.defaultValue;
          } else if (field.type === 'autocomplete') {
            campaignData[field.name] = field.defaultValue;
          } else if (field.type === 'multiple_options') {
            var newOption = {};
            field.template.forEach(template => {
              newOption[template.name] = '';
              if (template.type === 'select') {
                newOption[template.name] = template.defaultValue;
              } else if (template.type === 'multiple_options') {
                newOption[template.name] = []
                newOption[template.name].push({})
                template.template[0].forEach(secondTemplate => {
                  newOption[template.name][0][secondTemplate.name] = '';
                })
              }
            });
            campaignData[field.name] = [newOption];
          } else if (field.type === 'radio') {
            campaignData[field.name] = field.defaultValue
          } else if (field.type === 'chips') {
            campaignData[field.name] = field.value;
          }

          // for campaign budget show or hide to client
          if (field.name === 'budget') {
            campaignData[field.showToClient.name] = field.showToClient.defaultValue;
          }
        });
      }
    });
  },
  async mounted() {
    // Update company select options
    if (this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH || this.currentUserRole === config.userRoles.SUPER_ADMIN_LOW) {
      companyAPIs
        .getAllCompanies(false)
        .then(response => {
          this.company_options = response.data;
        })
        .catch(error => {
          // Request failed.
          console.log('error', error);
        });
    }

    // Update client select options
    if (
      this.currentUserRole === config.userRoles.SUPER_ADMIN_HIGH ||
      this.currentUserRole === config.userRoles.SUPER_ADMIN_LOW ||
      this.currentUserRole === config.userRoles.COMPANY_ADMIN_HIGH ||
      this.currentUserRole === config.userRoles.COMPANY_ADMIN_LOW ||
      this.currentUserRole === config.userRoles.AD_STRATEGIST ||
      this.currentUserRole === config.userRoles.ACCOUNT_MANAGER
    ) {
      clientAPIs
        .getAllClients(false)
        .then(response => {
          this.allClients = response.data;
        })
        .catch(error => {
          // Request failed.
          console.log('error', error);
        });

      // Get all AM user by role
      userAPIs
        .getAllUsersByRole(config.userRoles.ACCOUNT_MANAGER)
        .then(response => {
          this.AM = response.users;
          this.selectedAM = response.users;
        })
        .catch(error => {
          console.log('error', error);
        });

      // Get all campaign verticals
      campaignAPIs
        .getAllCampaignVerticals(false)
        .then(response => {
          this.campaignVerticals = response.data
        })
        .catch(error => {
          console.log('error', error);
        });
      // await this.$store.dispatch('campaign/getCountries')
    }

    // Update companyID
    if (
      this.currentUserRole === config.userRoles.COMPANY_ADMIN_HIGH ||
      this.currentUserRole === config.userRoles.COMPANY_ADMIN_LOW ||
      this.currentUserRole === config.userRoles.AD_STRATEGIST ||
      this.currentUserRole === config.userRoles.ACCOUNT_MANAGER
    ) {
      this.campaign.companyID = this.$store.state.user.companyID;
    }
    this.initFileUpload();
    this.images = []
    this.angelOptions = []
    this.getCountries()
  }
};
</script>
<style>
.action-required {
  margin: 0px 5px;
}
.custom-input {
  background: white;
  min-width: 300px;
  height: 30px;
  padding: 5px;
  border: 1px solid #d1d1d1;
}
</style>



// WEBPACK FOOTER //
// CreateCampaignModal.vue?f51ecde8